// components/SelectControl.js
import styled from "styled-components";

const StyledFilter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  background-color: var(--color-grey-200);
  border-radius: 2rem;
  width: 25rem;
  box-shadow: var(--box-shadow);

  p {
    margin-right: 0.5rem;
    font-size: 1.3rem;
  }

  select {
    border: none;
    outline: none;
    background-color: var(--color-grey-200);
    color: var(--color-grey-900);
    padding: 0.5rem;
    border-radius: 1rem;
    text-align: center;
    font-size: 1.3rem;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-image: url("path_to_your_arrow_icon.png");
    background-repeat: no-repeat;
    background-position: right 0.5rem center;
    padding-right: 2rem;
  }
`;

function Filter({ label, options, onChange }) {
  return (
    <StyledFilter>
      <p>{label}</p>
      <select onChange={onChange}>
        {options.map((option) => (
          <option key={option}>{option}</option>
        ))}
      </select>
    </StyledFilter>
  );
}

export default Filter;
